import type { SectionComponentProps } from "./registry";

type BentoItem = {
  title: string;
  content: string;
  span?: "1x1" | "2x1" | "1x2" | "2x2";
  icon?: string;
  color?: string;
};

const SPAN_CLASSES: Record<string, string> = {
  "1x1": "col-span-1 row-span-1",
  "2x1": "col-span-2 row-span-1",
  "1x2": "col-span-1 row-span-2",
  "2x2": "col-span-2 row-span-2",
};

export function BentoGridSection({ data }: SectionComponentProps) {
  const items = data as BentoItem[];
  if (!items?.length) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[140px] gap-3">
      {items.map((item, i) => {
        const spanClass = SPAN_CLASSES[item.span ?? "1x1"] ?? SPAN_CLASSES["1x1"];
        const color = item.color ?? "#a78bfa";

        return (
          <div
            key={i}
            className={`${spanClass} rounded-xl border bg-card p-4 flex flex-col justify-between hover:border-violet-500/30 transition-colors overflow-hidden`}
          >
            <div>
              {item.icon && <span className="text-xl mb-2 block">{item.icon}</span>}
              <h3 className="text-sm font-semibold text-foreground">{item.title}</h3>
            </div>
            <p className="text-xs text-muted-foreground leading-relaxed line-clamp-3 mt-2">
              {item.content}
            </p>
            <div
              className="absolute bottom-0 start-0 h-[2px] w-full opacity-40"
              style={{ backgroundColor: color }}
            />
          </div>
        );
      })}
    </div>
  );
}
